//system
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, HttpServiceConfig } from './common/http.service';
import { HttpHeaders } from '@angular/common/http';

//services
import { LogService } from './common/log.service';

//models
import { CancelMembershipRequest, CancellationPreview, MembershipCancellationRequest, PurchasePreview, PurchaseRequest, TransitionRequest } from '../models/currency';
import { MenuPack, Pack } from '../models/meta';
import { EnvironmentService } from './environment.service';
import { RepositoryResult } from '../models/common-models';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  
  constructor(private logService: LogService
    , private httpService: HttpService
    , private _environmentService: EnvironmentService
  ) { 
    const config: HttpServiceConfig = {
      baseUrl: `${this._environmentService.getFacilityConfig().facilityUrl}api/v${this._environmentService.getFacilityConfig().facilityApiVersion}`
    };
    this.httpService.configure(config);
  }

  purchasePreview(purchaseRequest: PurchaseRequest): Observable<RepositoryResult<PurchasePreview>> {
    return this.httpService.post<RepositoryResult<PurchasePreview>>(`Currency/MenuPack/PurchasePreview`, purchaseRequest, new HttpHeaders(), true);
  }

  purchase(purchaseRequest: PurchaseRequest): Observable<boolean | string> {
    return this.httpService.post<boolean | string>(`Currency/MenuPack/PurchaseV2`, purchaseRequest, new HttpHeaders(), true);
  }

  /** DFS-2020: change membership (Upgrade Now / Next Cycle). */
  transition(request: TransitionRequest): Observable<boolean | string> {
    return this.httpService.post<boolean | string>(`Currency/MenuPack/TransitionV2`, request, new HttpHeaders(), true);
  }


  renew(memberId: number, bookingId: number): Observable<boolean | string> {
    return this.httpService.post<boolean | string>(`Currency/MenuPack/Renew/${memberId}/${bookingId}`, null, new HttpHeaders(), true);
  }

  getCancellationPreview(bookingId: number): Observable<CancellationPreview> {
    return this.httpService.get<CancellationPreview>(`Membership/CancellationRequest/Preview/${bookingId}`);
  }

  cancelSubscription(request: CancelMembershipRequest): Observable<MembershipCancellationRequest> {
    return this.httpService.post<MembershipCancellationRequest>(`Membership/CancellationRequest`, request, new HttpHeaders(), true);
  }

  pauseSubscription(bookingId: number): Observable<number | string> {
    return this.httpService.put<number | string>(`Membership/Booking/Pause/${bookingId}`, null);
  }

  resumeSubscription(bookingId: number): Observable<number | string> {
    return this.httpService.put<number | string>(`Membership/Booking/Resume/${bookingId}`, null);
  }

  cancelCancellationRequest(request: CancelMembershipRequest): Observable<MembershipCancellationRequest> {
    return this.httpService.delete<MembershipCancellationRequest>(`Membership/CancellationRequest`, request, new HttpHeaders());
  }

  getMenuPackById(menuPackId: number): Promise<MenuPack> {
    return this.httpService.getPromise<MenuPack>(`Currency/MenuPack/${menuPackId}`);
  }

  getPackById(packId: number): Promise<Pack> {
    return this.httpService.getPromise<Pack>(`Currency/Pack/${packId}`);
  }
}